<div class="container" xmlns="http://www.w3.org/1999/html">

  <app-page-title [title]="'Home'" [icon]="'bi-house'">

  </app-page-title>

  <div class="row mt-4">
    <div class="col-12">
      <p>This built-in AI playground presents all the AI features directly available in Chrome as JS APIs:</p>

      <ul class="list-unstyled mt-4">
        <li><a class="btn btn-light" routerLink="translator-api"><i class="bi bi-translate"></i> Translator API</a></li>
        <li class="mt-3"><a class="btn btn-light" routerLink="language-detector-api"><i class="bi bi-globe2"></i>
          Language Detector API</a></li>
        <li class="mt-3"><a class="btn btn-light" routerLink="summarizer-api"><i class="bi bi-text-paragraph"></i>
          Summarizer API</a></li>
        <li class="mt-3"><a class="btn btn-light" routerLink="writer-api"><i class="bi bi-pencil-square"></i> Writer API</a>
        </li>
        <li class="mt-3"><a class="btn btn-light" routerLink="rewriter-api"><i class="bi bi-arrow-clockwise"></i>
          Rewriter API</a></li>
        <li class="mt-3"><a class="btn btn-light" routerLink="prompt-api"><i class="bi bi-input-cursor-text"></i> Prompt
          API</a></li>
        <li class="mt-3"><a class="btn btn-light" routerLink="semantic-embedder-api"><i class="bi bi-diagram-3"></i>
          Semantic Embedder API</a></li>
      </ul>
    </div>
  </div>

  <h2 class="display-6 mt-3">Want to get started?</h2>

  <p>Kickstart the download of the model here:</p>

  <div>
    @if (downloadStatus === TaskStatus.Executing) {
      <div class="alert alert-primary">
        <strong>Downloading...</strong>

        <div class="flex-grow-1 me-4 mt-2">
          <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="0"
               aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar" [style.width]="getDownloadProgress() + '%'">{{ getDownloadProgress() }}%</div>
          </div>
        </div>
      </div>
    } @else if(downloadStatus === TaskStatus.Completed) {
      <div class="alert alert-success">
        Model successfully downloaded! <strong>You are all set!</strong> Go and explore all the pages this site has to offer.
      </div>
    }@else if(downloadStatus === TaskStatus.Error) {
      <div class="alert alert-danger">
        Error: <strong>{{ this.error }}</strong>
      </div>
    }

    @if (downloadStatus === TaskStatus.Executing) {
      <button class="btn btn-outline-light btn-large" (click)="cancelDownload()">
        Cancel download
      </button>
    }@else if(downloadStatus === TaskStatus.Idle) {
      <button class="btn btn-primary btn-large" (click)="download()">
        Download Gemini Nano
      </button>
    }

  </div>

  <h2 class="display-6 mt-3">Want to use it yourself?</h2>
  <p>Join the <a href="https://developer.chrome.com/docs/ai/join-epp">Early Preview Program</a> today!</p>

  <h2 class="display-6 mt-3">Questions?</h2>

  <p class="mt-3">Contact me, <a href="https://etiennenoel.com">Etienne Noël</a></p>
  <div>
    <a class="btn btn-light btn-lg" href="https://x.com/etiennenoel"><i class="bi bi-twitter-x"></i></a>
    <a class="btn btn-light btn-lg ms-2" href="https://www.linkedin.com/in/enoel19/"><i class="bi bi-linkedin"></i></a>
  </div>
</div>
